// Guarded service worker registration for PWA + offline + push.
// Refuses to register in dev / iframe / Lovable preview hosts / ?sw=off.

const PREVIEW_HOST_PREFIXES = ['id-preview--', 'preview--'];
const PREVIEW_HOST_SUFFIXES = [
  '.lovableproject.com',
  '.lovableproject-dev.com',
  '.beta.lovable.dev',
];
const PREVIEW_HOST_EXACT = [
  'lovableproject.com',
  'lovableproject-dev.com',
  'beta.lovable.dev',
];

function isPreviewContext(): boolean {
  if (typeof window === 'undefined') return true;
  if (!import.meta.env.PROD) return true;
  try {
    if (window.self !== window.top) return true;
  } catch {
    return true;
  }
  const host = window.location.hostname;
  if (PREVIEW_HOST_EXACT.includes(host)) return true;
  if (PREVIEW_HOST_PREFIXES.some((p) => host.startsWith(p))) return true;
  if (PREVIEW_HOST_SUFFIXES.some((s) => host.endsWith(s))) return true;
  if (new URL(window.location.href).searchParams.get('sw') === 'off') return true;
  return false;
}

async function unregisterAppSW() {
  if (!('serviceWorker' in navigator)) return;
  try {
    const regs = await navigator.serviceWorker.getRegistrations();
    for (const r of regs) {
      const url = r.active?.scriptURL || r.installing?.scriptURL || r.waiting?.scriptURL || '';
      if (url.endsWith('/sw.js')) await r.unregister();
    }
  } catch {
    /* ignore */
  }
}

export function registerServiceWorker() {
  if (typeof window === 'undefined') return;
  if (!('serviceWorker' in navigator)) return;

  if (isPreviewContext()) {
    void unregisterAppSW();
    return;
  }

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then((reg) => console.log('[SW] Registered', reg.scope))
      .catch((err) => console.warn('[SW] Registration failed', err));
  });
}
